import React from 'react';

function Resources() {
  return (
    <div className="resources-page fade-in">
      <h1>Resources</h1>
      <p style={{ textAlign: 'center', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-2xl)', maxWidth: '600px', margin: '0 auto var(--space-2xl)' }}>
        Tools and resources to support your navigational practice.
      </p>

      <div className="resource-section">
        <h2>Navigation Tools</h2>
        <div className="resource-cards">
          <a href="https://navigationalmind.com" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>NMA Clarity</h3>
            <p>Navigate alone with AI-powered clarity using the Navigational Mind Architecture.</p>
            <span className="url">navigationalmind.com</span>
          </a>
          
          <a href="https://navigationalmind.com/multi-clarity" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>Group Clarity</h3>
            <p>Navigate together—multi-party navigation for couples, teams, and groups.</p>
            <span className="url">navigationalmind.com/multi-clarity</span>
          </a>
          
          <a href="https://navigationalmind.com/console" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>NMA Console</h3>
            <p>Explore the map—a deeper interface for working with the framework.</p>
            <span className="url">navigationalmind.com/console</span>
          </a>
        </div>
      </div>

      <div className="resource-section">
        <h2>Specialized Compasses</h2>
        <div className="resource-cards">
          <a href="https://drtoye.ca/compass" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>The Compass</h3>
            <p>Navigate the uncertainty of living with chronic illness. Treatment decisions, lifestyle trade-offs, what matters most.</p>
            <span className="url">drtoye.ca/compass</span>
          </a>
          
          <a href="https://drtoye.ca/caregiver" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>The Caregiver's Compass</h3>
            <p>For those navigating the impossible decisions of caregiving.</p>
            <span className="url">drtoye.ca/caregiver</span>
          </a>
          
          <a href="https://drtoye.ca/founder" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>The Founder's Compass</h3>
            <p>Navigate startup uncertainty. Hiring, pivots, funding—see the terrain before you move.</p>
            <span className="url">drtoye.ca/founder</span>
          </a>
          
          <a href="https://drtoye.ca/ethics" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>The Ethical Crossroads</h3>
            <p>When you see something wrong at work but the path forward isn't clear.</p>
            <span className="url">drtoye.ca/ethics</span>
          </a>
          
          <a href="https://drtoye.ca/threshold" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>The Threshold</h3>
            <p>Standing at the edge of major change—career shifts, relationship decisions, geographic moves.</p>
            <span className="url">drtoye.ca/threshold</span>
          </a>
        </div>
      </div>

      <div className="resource-section">
        <h2>Epistemic Tools</h2>
        <div className="resource-cards">
          <a href="https://navigationalfidelity.com" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>Truth Engine</h3>
            <p>Epistemic truth assessment using the NMA-6 Double-Gate Protocol. Analyze any text for truth fidelity.</p>
            <span className="url">navigationalfidelity.com</span>
          </a>
        </div>
      </div>

      <div className="resource-section">
        <h2>Learn More</h2>
        <div className="resource-cards">
          <a href="https://navigational-mind-6fnpsq.jellypod.ai" target="_blank" rel="noopener noreferrer" className="resource-card">
            <h3>Navigational Mind Podcast</h3>
            <p>Explore the framework through conversation. Deep dives into concepts, applications, and the philosophy behind navigation.</p>
            <span className="url">Jellypod</span>
          </a>
        </div>
      </div>

      <div style={{ 
        marginTop: 'var(--space-3xl)', 
        padding: 'var(--space-xl)', 
        background: 'var(--color-bg-secondary)', 
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <h3 style={{ color: 'var(--color-accent)', marginBottom: 'var(--space-md)' }}>About the Framework</h3>
        <p style={{ color: 'var(--color-text-secondary)', maxWidth: '600px', margin: '0 auto' }}>
          The Navigational Mind Framework was developed by Dr. Toye Oyelese, Clinical Associate 
          Professor at UBC Faculty of Medicine and Medical Director of Westside Medical Associates Ltd. 
          It emerged from three decades of clinical practice, personal reconstruction, and sustained 
          attention to how minds actually behave.
        </p>
      </div>
    </div>
  );
}

export default Resources;
